/* eslint-disable */
// 分，时，天，转秒
const DATE_CONFIG = {
    m: 60,
    h: 3600,
    d: 86400,
    daysOfYeay: 365
}

// 毫秒转秒
export function millisecond2Second(millisecond) {
    return Math.round(millisecond / 1000)
}

// 计算时间戳之间的秒差
export function relativeSeconds(startStamp, endStamp) {
    if (endStamp) {
        return millisecond2Second(endStamp - startStamp)
    } else {
        const endStamp = new Date().valueOf()
        return millisecond2Second(endStamp - startStamp)
    }
}

// 秒转时分秒
export function seconds2Date(seconds) {
    const dateObj = {
        h: 0,
        m: 0,
        s: 0
    }
    if (seconds < DATE_CONFIG.m) {
        dateObj.s = seconds
        return dateObj
    } else if (seconds < DATE_CONFIG.h) {
        dateObj.m = Math.round(seconds / DATE_CONFIG.m)
        return dateObj
    } else if (seconds < DATE_CONFIG.d) {
        dateObj.h = Math.round(seconds / DATE_CONFIG.h)
        return dateObj
    }
    return dateObj
}

// 获取两个日期之间的相隔天数
export function relativeDays(startStamp, endStamp) {
    return new Date(endStamp).diff(new Date(startStamp), 'day')
}

// 获取两个日期之间的相隔多少年
export function relativeYears(startStamp, endStamp) {
    return new Date(endStamp).year() - new Date(startStamp).year()
}

/**
 * 人性化显示时间
 *
 * @param {number | string} date 时间（时间戳或者字符）默认是时间戳
 * @param {object} [options] 配置项(可选)
 * @param {boolean} options.isString 指定date类型：默认是false. false:数字时间戳 true: YYYY-MM-DD HH:mm:ss (ISO 8601 string)
 * @param {number} options.adjustVal 校正值。单位秒。即两时间相差{adjustVal}显示为刚刚。默认：0
 */
export function getHumanDate(date,isBefore, options = {}) {
    let minute = 1000 * 60;
    let hour = minute * 60;
    let day = hour * 24;
    let halfamonth = day * 15;
    let month = day * 30;

    let now = new Date().getTime();
    let diffValue = isBefore?now - date : date-now;

    let monthC =diffValue/month;
    let halfamonthC =diffValue/halfamonth;
    let weekC =diffValue/(7*day);
    let dayC =diffValue/day;
    let hourC =diffValue/hour;
    let minC =diffValue/minute;
    let result = "";
    // console.log(monthC+"halfamonthC"+halfamonthC+"weekC"+weekC+"dayC"+dayC+"hourC"+hourC+"minC"+minC);
    if(monthC>=1){
        result = parseInt(monthC) +"个月" + (isBefore?"前":"");
    }
    else if (halfamonthC>=1){
        result = "半个月" + (isBefore?"前":"");
    }
    else if (weekC>=1){
        result = parseInt(weekC) +"周" + (isBefore?"前":"");
    }
    else if (dayC>=1){
        result = parseInt(dayC) +"天" + (isBefore?"前":"");
    }
    // else if (hourC>=12){
    //     result = "半天前";
    // }
    else if(hourC>=1){
        result = parseInt(hourC) +"小时" + (isBefore?"前":"");
    }
    else if(minC>=1){
        result = parseInt(minC) +"分钟" + (isBefore?"前":"");
    }else
        result =  + isBefore?"刚刚":"已过期";

    // console.log("result"+result);
    return result;
}

// 时间戳转日期
export function formatDate(value) {
    let date = new Date(value);
    let y = date.getFullYear();// 年
    let MM = date.getMonth() + 1;// 月
    MM = MM < 10 ? ('0' + MM) : MM;
    let d = date.getDate();// 日
    d = d < 10 ? ('0' + d) : d;
    let h = date.getHours();// 时
    h = h < 10 ? ('0' + h) : h;
    let m = date.getMinutes();// 分
    m = m < 10 ? ('0' + m) : m;
    let s = date.getSeconds();// 秒
    s = s < 10 ? ('0' + s) : s;
    let timer = y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
    return timer
}
  

export default {millisecond2Second, relativeSeconds, seconds2Date, relativeDays, relativeYears, getHumanDate,formatDate}




// WEBPACK FOOTER //
// ./src/utils/date.js